import React from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import CollapsedField from '../CollapsedField/CollapsedField';
import { Field, Form, getFormValues, reduxForm, submit } from 'redux-form';
import { Button, Loader } from '../../../../common/components';
import { compose } from 'redux';

const FIELD_KEY_MAP = {
  B2C: 'B2C',
  DIR: 'Call Centre',
  B2B: 'B2B',
};
const DeclarationField = ({
  title,
  input,
  onSave
}) => {
  const declarationTypes = Object.keys(FIELD_KEY_MAP);
  return (
    <>
      <h2>{title}</h2>
      {declarationTypes.map((declarationType) => (
        <Field
          name={`${input.name}.${declarationType}`}
          component={CollapsedField}
          label={FIELD_KEY_MAP?.[declarationType]}
          onSave={onSave}
        />
      ))}
    </>
  );
};

const DeclarationForm = ({
  handleSubmit,
  submit,
  submitting,
  formValues,
  onUpdateDeclaration,
}) => {

  if (!formValues) {
    return <Loader/>;
  }

  const handleSave = () => {
    submit(FORM_NAME);

  };

  return (
    <Form onSubmit={handleSubmit(onUpdateDeclaration)}>
      <Field
        title={'Purchase Declaration'}
        name={'data.attributes.metadata.purchase_declaration'}
        component={DeclarationField}
        isLoading={submitting}
        onSave={handleSave}
      />
      <Field
        title={'Mta Declaration'}
        name={'data.attributes.metadata.mta_declaration'}
        component={DeclarationField}
        isLoading={submitting}
        onSave={handleSave}
      />
      <Field
        title={'Renewal Declaration'}
        name={'data.attributes.metadata.renewal_declaration'}
        component={DeclarationField}
        isLoading={submitting}
        onSave={handleSave}
      />
      <div className="divider margin-bottom"/>
      <Row>
        <Col sm={12}>
          <Button bsStyle="default" link={true} to={'/admin/products'}>
            Back
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const FORM_NAME = 'DeclarationForm';

export default compose(
  connect(
    (state, props) => {
      return {
        initialValues: props.product,
        formValues: getFormValues(FORM_NAME)(state),
      };
    },
    {
      submit: submit
    },
  ),
  reduxForm({
    form: FORM_NAME,
  }),
)(DeclarationForm);
